import { useMemo } from "react";
import { t } from "@/i18n-js/instance";
import { LineChartComponent } from "@/react/components/Analytics/components/LineChartComponent";
import type { ChartDataItem } from "@/react/components/Analytics/components/types";
import { i18nRoot } from "../../constants";
import { completionColors, completionSeriesKeys } from "../constants";
import { useVideoAnalyticsAverageProgressTimeline } from "../hooks/useVideoAnalyticsTimeline";

interface CompletionChartProps {
  dateGrouping?: string;
  endDate?: string;
  signedId: string;
  startDate?: string;
}

export const CompletionChart = ({
  signedId,
  startDate,
  endDate,
  dateGrouping,
}: CompletionChartProps) => {
  const { data: timelineData, isLoading } =
    useVideoAnalyticsAverageProgressTimeline({
      signedId,
      startDate,
      endDate,
      dateGrouping,
    });

  const chartData = useMemo((): ChartDataItem[] => {
    if (!timelineData || timelineData.length === 0) {
      return [];
    }

    return timelineData.map(item => ({
      id: item.date_period,
      label: item.date_period,
      avg_completion: item.avg_progress_percent,
    }));
  }, [timelineData]);

  return (
    <div className="mb-8">
      <LineChartComponent
        title={t([i18nRoot, "analytics.chart.completion_timeline.title"])}
        tooltip={t([i18nRoot, "analytics.chart.completion_timeline.tooltip"])}
        data={chartData}
        indexBy="label"
        seriesKeys={completionSeriesKeys}
        colors={completionColors}
        suffix="%"
        rootLocale={[i18nRoot, "analytics.chart.completion_timeline.lines"]}
        className="w-full"
        isLoading={isLoading}
      />
    </div>
  );
};
